import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useEffect, useState } from "react";
import UserTransferList from "../../components/user-transfer-list/user-transfer-list.component";
import dataProvider from "../../providers/data-provider";
import { Save } from "@material-ui/icons";

const ActivityEditAddStudent = ({ record, resource, refresh, path, title, disabled, ...props }) => {

    const [open, setOpen] = useState(false);
    const [users, setUsers] = useState([]);
    const [selected, setSelected] = useState([])
    const [loading, setLoading] = useState(false);
    const [loadingFilter, setLoadingFilter] = useState(false);
    const [classes, setClasses] = useState([]);
    const [selectedClass, setSelectedClass] = useState(null);

    useEffect(() => {
        const getData = async () => {
            const response = await dataProvider.getList('classes', {
                pagination: { page: 1, perPage: 999 },
                sort: { field: 'name', order: 'ASC' },
                filter: {
                    'academic_period': 'current',
                    'institution_branch': record.institution_branch?.id,
                    'has_office_access': true,
                }
            })
            setClasses(response.data)
        }
        getData();
    }, [record.institution_branch])

    const handleFilterClasses = async (event, value) => {
        setSelectedClass(value)
        setLoadingFilter(true)
        if (value && value.id) {
            await dataProvider.getList(
                'user-contexts',
                {
                    pagination: { page: 1, perPage: 999 },
                    sort: { field: 'user.name', order: 'ASC' },
                    filter: {
                        'profiles': ['\'Aluno\''],
                        'active': true,
                        'institution_branch': record.institution_branch?.id,
                        'classId': value?.id
                    }
                })
                .then((response) => {
                    setLoadingFilter(false)
                    setUsers(filterUsers(response.data))
                })
        } else {
            setUsers([])
            setLoadingFilter(false)
        }
    }

    const handleSubmit = () => {
        setLoading(true)
        dataProvider.create(`${resource}/${record.id}/${path}`, { data: { user_contexts: selected } })
            .then(() => { refresh(); setTimeout(() => { }, 2000) })
            .finally(() => { setLoading(false); setOpen(false); })
    }

    const handleClose = () => {
        setSelected([])
        setSelectedClass(null)
        setUsers([])
        setLoading(false)
        setLoadingFilter(false)
        setOpen(false)
    }

    const filterUsers = (data) => {
        return data.filter(item => !record.students?.find(i => i.id === item.id))
    };

    return (
        <div style={{ width: '100%', textAlign: 'left' }}>
            <Dialog maxWidth={"lg"} fullWidth open={open} onClose={handleClose}>
                <DialogTitle>{title}</DialogTitle>
                <DialogContent dividers>
                    <Autocomplete
                        id='combobox-select'
                        options={classes}
                        getOptionLabel={c => c.name || 'Selecione...'}
                        getOptionSelected={(o, s) => o.id === s.id}
                        noOptionsText={'Sem resultados'}
                        value={selectedClass}
                        size={'small'}
                        onChange={handleFilterClasses}
                        disabled={loadingFilter}
                        renderInput={(params) => <TextField {...params} variant="filled" label={'Turma'} />}
                        style={{ width: '91.666667%', justifySelf: 'center', marginBottom: '16px' }}
                        loading={loadingFilter}
                    />
                    <UserTransferList
                        data={users}
                        selected={selected}
                        setSelected={setSelected}
                        loading={loadingFilter}
                        key={record.institution_branch?.id}
                        disabled={loadingFilter}
                    />
                    <DialogActions>
                        <Button onClick={handleClose} size={'medium'} variant={'contained'} color={'default'}> Cancelar </Button>
                        <span style={{ flexGrow: 1 }} />
                        <Button
                            onClick={handleSubmit}
                            size={'medium'}
                            variant={'contained'}
                            color={'primary'}
                            startIcon={loading ? <CircularProgress size={16} /> : <Save />}
                            disabled={loading || selected.length === 0}
                        >
                            Confirmar
                        </Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
            <Button onClick={() => setOpen(true)} size={'small'} variant={'contained'} color={'primary'} disabled={disabled}>
                Adicionar usuários
            </Button>
        </div>
    )
};

export default ActivityEditAddStudent;
